import * as fflate from "fflate"

const stringDecodeTable = [
	0xff, // space
	0x44, // !
	0xff, // "
	0x54, // #
	0x53, // $
	0x52, // %
	0xff, // &
	0x49, // '
	0x4b, // (
	0x4c, // )
	0x46, // *
	0x41, // +
	0xff, // ,
	0x3f, // -
	0x3e, // .
	0x45, // /

	0x00,
	0x01,
	0x02,
	0x03,
	0x04, // 01234
	0x05,
	0x06,
	0x07,
	0x08,
	0x09, // 56789

	0x40, // :
	0xff, // ;
	0xff, // <
	0x42, // =
	0xff, // >
	0x47, // ?
	0x51, // @

	0x24,
	0x25,
	0x26,
	0x27,
	0x28, // ABCDE
	0x29,
	0x2a,
	0x2b,
	0x2c,
	0x2d, // FGHIJ
	0x2e,
	0x2f,
	0x30,
	0x31,
	0x32, // KLMNO
	0x33,
	0x34,
	0x35,
	0x36,
	0x37, // PQRST
	0x38,
	0x39,
	0x3a,
	0x3b,
	0x3c, // UVWXY
	0x3d, // Z

	0x4d, // [
	0xff, // backslash
	0x4e, // ]
	0x43, // ^
	0xff, // _
	0x48, // `

	0x0a,
	0x0b,
	0x0c,
	0x0d,
	0x0e, // abcde
	0x0f,
	0x10,
	0x11,
	0x12,
	0x13, // fghij
	0x14,
	0x15,
	0x16,
	0x17,
	0x18, // klmno
	0x19,
	0x1a,
	0x1b,
	0x1c,
	0x1d, // pqrst
	0x1e,
	0x1f,
	0x20,
	0x21,
	0x22, // uvwxy
	0x23, // z

	0x4f, // {
	0x4a, // |
	0x50, // }
	0xff, // ~
	0xff, // del
]

// From DNG SDK (dng_big_table::DecodeFromString)
export function decodeTableFromString(str: string) {
	let compressedSize = 0
	let phase = 0
	let value = 0

	const encodedSize = str.length
	const maxCompressedSize = ((encodedSize + 4) / 5) * 4
	const buffer = new Uint8Array(maxCompressedSize)

	let dPtr = 0

	for (let i = 0; i < str.length; i++) {
		const e = str.charCodeAt(i)

		if (e < 32 || e > 127) {
			continue
		}

		const d = stringDecodeTable[e - 32] || 0

		if (d > 85) {
			continue
		}

		phase++

		if (phase == 1) {
			value = d
		} else if (phase == 2) {
			value += d * 85
		} else if (phase == 3) {
			value += d * (85 * 85)
		} else if (phase == 4) {
			value += d * (85 * 85 * 85)
		} else {
			value += d * (85 * 85 * 85 * 85)

			buffer[dPtr + 0] = value
			buffer[dPtr + 1] = value >> 8
			buffer[dPtr + 2] = value >> 16
			buffer[dPtr + 3] = value >> 24

			dPtr += 4

			compressedSize += 4

			phase = 0
		}
	}

	if (phase > 3) {
		buffer[dPtr + 2] = value >> 16

		compressedSize++
	}

	if (phase > 2) {
		buffer[dPtr + 1] = value >> 8

		compressedSize++
	}

	if (phase > 1) {
		buffer[dPtr + 0] = value

		compressedSize++
	}

	return decodeTableFromBinary(buffer, compressedSize)
}

function decodeTableFromBinary(compressedData: Uint8Array, compressedSize: number) {
	if (compressedSize < 5) {
		throw new Error("Invalid table data")
	}

	const data = compressedData.subarray(4, compressedSize)

	return fflate.decompressSync(data)
}
